import {Map as MapBase, MapBoundsLocation, Route, useLocationsRequest} from '@logistics-frontend/blocks'
import {Point} from '@logistics-frontend/core/types'
import {isPoint} from '@yandex-taxi/react-integration-api'
import {memo, useMemo, useState} from 'react'

import {config} from 'src/config'

import {MapData, MapModes} from '../../types'
import {isPerformerImageLoadable} from '../../utils'
import {useMargin} from '../margin-provider'
import {CourierPlacemark} from './courier'
import {classes} from './Map.classes'
import {useBoundsByMode} from './Map.hooks'
import {PointPlacemark} from './point'

type Props = MapData

function Map({position, route, pin, direction, mode, bubbleText}: Props) {
  const margin = useMargin()
  const [bounds, setBounds] = useState<MapBoundsLocation & {duration: number}>()
  const boundsByMode = useBoundsByMode(bounds, mode)
  const performer = useMemo(() => {
    if (!position || !pin) {
      return
    }
    if (isPerformerImageLoadable(pin)) {
      return {direction, point: position, tag: pin.image_tag, anchor: pin.anchor}
    }
    return {direction, point: position}
  }, [direction, pin, position])

  const placemarkCoords = [MapModes.WaitCourier, MapModes.SearchCourier].includes(mode)
    ? route?.[0]?.point
    : route?.[route.length - 1]?.point
  const points = useMemo(
    () =>
      [MapModes.WaitCourier, MapModes.Transporting].includes(mode)
        ? [position, route?.[0]?.point].filter<Point>(isPoint)
        : undefined,
    [mode, position, route],
  )
  const locationRequest = useLocationsRequest({
    bounds: boundsByMode,
    centerCoords: placemarkCoords,
  })

  return (
    <div className={classes.container}>
      <MapBase lang={config.mapLang} location={locationRequest} margin={margin}>
        {placemarkCoords && <PointPlacemark coords={placemarkCoords} />}
        {points && <Route onBoundsChange={setBounds} points={points} />}
        {performer && <CourierPlacemark bubbleText={bubbleText} performer={performer} />}
      </MapBase>
    </div>
  )
}
export default memo(Map)
